export enum ChartType {
  Bar = 'bar',
  HorizontalBar = 'horizontal-bar',
  Line = 'line',
  Area = 'area',
}
